import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=fb99cd40&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb99cd40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb99cd40')) {
      api.createRecord('fb99cd40', component.options)
    } else {
      api.reload('fb99cd40', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=fb99cd40&scoped=true&", function () {
      api.rerender('fb99cd40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8fRnqRO5PF26x/JS/comp/Accordion.vue"
export default component.exports